import React from 'react';
import styled from 'styled-components';
import { space, layout } from 'styled-system';

import { ExternalLinkProps } from './ExternalLink.types';

const ExternalLinkWrapper = styled.a<Partial<ExternalLinkProps>>`
  display: ${(props) => (props.inline ? 'inline-block' : 'flex')};
  align-items: center;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  ${space}
  ${layout}

  * {
    cursor: pointer !important;
  }
`;

const ExternalLink: React.FC<ExternalLinkProps> = (props: ExternalLinkProps) => {
  const {
    children,
    link,
    target,
    classNames,
    inline = false,
    overrideRtl = false,
    disabled = false,
    ariaLabel,
    ...rest
  } = props;

  const preventClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <ExternalLinkWrapper
      href={disabled ? '' : link || ''}
      overrideRtl={overrideRtl}
      target={target ?? '_self'}
      className={classNames ?? ''}
      inline={inline}
      onClick={(e) => (!link || disabled) && preventClick(e)}
      aria-label={ariaLabel}
      {...rest}
    >
      {children}
    </ExternalLinkWrapper>
  );
};

export default ExternalLink;
